import posthog from 'posthog-js';
import type { TelemetryAdapter, TelemetryUser } from '../types';

export function createPostHogAdapter(): TelemetryAdapter {
  return {
    name: 'posthog',
    identify(user: TelemetryUser) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        orgName: user.orgName,
        tenant: user.tenant,
        roles: user.roles,
      });

      // Group analytics — enables tenant/org-level aggregation in PostHog
      // (e.g., "which tenant has the most errors?")
      if (user.tenant) {
        posthog.group('tenant', user.tenant, {
          name: user.tenant,
          orgName: user.orgName,
        });
      }
    },
    trackEvent(name: string, properties?: Record<string, unknown>) {
      posthog.capture(name, properties);
    },
  };
}
